module.exports = __webpack_public_path__ + "static/media/login-logo.af8e7412.svg";